"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileVersionsApiService = void 0;
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var SeismicHelper_1 = require("../../helper/SeismicHelper");
var Http_service_1 = require("../../../core/services/http/Http.service");
var BaseGlobalHeaders_service_1 = require("../../../core/services/BaseGlobalHeaders.service");
var ProfileVersionsApiService = /** @class */ (function () {
    function ProfileVersionsApiService(httpService, globalHeadersService, seismicHelper) {
        this.httpService = httpService;
        this.globalHeadersService = globalHeadersService;
        this.seismicHelper = seismicHelper;
    }
    /**
     * Gets list of delivery options that have been disabled for the given folders/documents
     * @param doccenterFullPath
     * @param folderOrDocumentIds
     * @param profileVersionId
     */
    ProfileVersionsApiService.prototype.getDeliveryOptions = function (doccenterFullPath, folderOrDocumentIds, profileVersionId) {
        if (!profileVersionId) {
            profileVersionId = this.globalHeadersService.getGlobalHeaders().ProfileVersionId;
        }
        var url = this.seismicHelper.getRootURL() + "/api/doccenter/v1/profileVersions/" + profileVersionId + "/folders/uniqueid/files/deliveryOptions/";
        return this.httpService.post(url, folderOrDocumentIds, {
            headers: {
                doccenterfullpath: doccenterFullPath,
                debug: true,
            },
        });
    };
    ProfileVersionsApiService = __decorate([
        CommonService_decorator_1.CommonService('ProfileVersionsApi'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            BaseGlobalHeaders_service_1.BaseGlobalHeadersService,
            SeismicHelper_1.SeismicHelper])
    ], ProfileVersionsApiService);
    return ProfileVersionsApiService;
}());
exports.ProfileVersionsApiService = ProfileVersionsApiService;
//# sourceMappingURL=ProfileVersionsApi.service.js.map